export class Player {
  constructor(
    public uid: string,
    public username: string,
  ){}
}



// WEBPACK FOOTER //
// /Users/Guest/Desktop/Space-Janitor/src/app/models/player.model.ts